import React, { useEffect } from 'react'

import BasicDetailsCard from '../../components/SalesforceAudit/common/BasicDetailsCard'
import { DDSTypography } from 'den-design-system'
import moment from 'moment'
import { observer } from 'mobx-react-lite'
import pallete from '../../global/newPallete'
import { replaceUrl } from '../../utils/UrlUtils'
import routeConstants from '../../constants/RouteConstants'
import { timeFormats } from '../../enum/TIME'
import { useParams } from 'react-router-dom'
import { useStoreContext } from '../../store/StoreContext'

const ApexClassDetails: React.FC = () => {
  const params = useParams()
  const store = useStoreContext()
  const { salesforceAuditStore } = useStoreContext()
  const paramTab = new URLSearchParams(location.search)
  const tabIndex = paramTab.get('tab')
  const data = salesforceAuditStore.getApexClassById(params.id!)

  useEffect(() => {
    store.breadcrumbStore.setMultipleBreadcrumbsOptions([
      {
        label: 'Salesforce Audit',
        link: replaceUrl(
          routeConstants.SALESFORCE_AUDIT_DASHBOARD,
          store.scopeStore.getScope()['organization-id'] as string,
          store.scopeStore.getScope()['project-id'] as string,
          store.scopeStore.getScope()['environment-id'] as string
        )
      },
      {
        label: 'Apex Classes',
        link:
          replaceUrl(
            routeConstants.SALESFORCE_AUDIT_METADATA_OVERVIEW + '/apex-classes',
            store.scopeStore.getScope()['organization-id'] as string,
            store.scopeStore.getScope()['project-id'] as string,
            store.scopeStore.getScope()['environment-id'] as string
          ) + `?tab=${tabIndex}`
      },
      {
        label: data?.Name,
        link: replaceUrl(
          routeConstants.SALESFORCE_AUDIT_METADATA_OVERVIEW + '/apex-classes',
          store.scopeStore.getScope()['organization-id'] as string,
          store.scopeStore.getScope()['project-id'] as string,
          store.scopeStore.getScope()['environment-id'] as string
        )
      }
    ])
  }, [store.breadcrumbStore.getBreadcrumbsOptions()])

  return (
    <div className='flex flex-col w-full py-[24px]'>
      <div className='flex flex-col pb-[12px]'>
        <DDSTypography.Title
          type='h5'
          variant='semiBold'
          color={pallete.colors.textDark3}
        >
          Basic Details
        </DDSTypography.Title>
      </div>
      <div className='grid grid-cols-3 gap-[16px] pb-[24px]'>
        <BasicDetailsCard
          id={data?.id}
          heading='API Version'
          content={data?.Name}
        />
        <BasicDetailsCard
          id={data?.id}
          heading='Last Modified'
          content={moment(data?.LastModifiedDate).format(
            timeFormats.shortMonthDateYearTime
          )}
        />
        <BasicDetailsCard
          id={data?.id}
          heading='Created On'
          content={moment(data?.CreatedDate).format(
            timeFormats.shortMonthDateYearTime
          )}
        />
        <BasicDetailsCard
          id={data?.id}
          heading='Length'
          content={data?.LengthWithoutComments}
        />
        <BasicDetailsCard
          id={data?.id}
          heading='Modified By'
          content={data?.LastModifiedBy?.Name}
        />
        <BasicDetailsCard
          id={data?.id}
          heading='Created By'
          content={data?.CreatedBy?.Name}
        />
      </div>
      <div
        style={{
          borderColor: pallete.colors.stroke2,
          borderRadius: '8px'
        }}
        className='border'
      >
        <div className='px-[16px] pt-[16px] pb-[8px]'>
          <DDSTypography.Title
            type='h5'
            variant='semiBold'
            color={pallete.colors.textDark3}
          >
            Apex Body
          </DDSTypography.Title>
        </div>

        <div
          style={{
            borderColor: pallete.colors.stroke2
          }}
          className='border-t'
        />

        <div
          className='px-[16px] py-[12px] max-h-[300px] overflow-auto'
          style={{ fontFamily: 'Mulish' }}
        >
          <div style={{ overflow: 'scroll', maxHeight: '300px' }}>
            <pre>
              <code>
                <DDSTypography.Paragraph
                  size='para'
                  color='#5A5F7D'
                  className='whitespace-pre-wrap'
                >
                  {data?.Body}
                </DDSTypography.Paragraph>
              </code>
            </pre>
          </div>
        </div>
      </div>
    </div>
  )
}
export default observer(ApexClassDetails)
